module.exports = __webpack_public_path__ + "img/sl.ee84be5f.png";